import isEqual from "lodash-es/isEqual"

export function getObjectDifference<T extends object, S extends object>(
  obj1: T,
  obj2: S
): Partial<T> {
  return Object.entries(obj1).reduce((current, [key, value]) => {
    if (!isEqual(value, obj2[key as keyof typeof obj2])) {
      return { ...current, [key]: value }
    }
    return current
  }, {}) as Partial<T>
}

export function getObjectProperty(
  obj: object,
  name: string,
  delimitier = "."
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  return name.split(delimitier).reduce((a, b) => a?.[b as keyof typeof a], obj)
}
